window.PH = window.PH || {};

PH.dna = {
  rules: [
    {
      keywords: ['sauvage', 'bleu', 'aventus', 'explorer', 'yves saint laurent y', 'ysl y'],
      family: 'Fresco amaderado',
      mood: ['elegante', 'versátil', 'oficina'],
      occasion: ['diario', 'oficina', 'cita casual'],
      gender: 'Caballero'
    },
    {
      keywords: ['good girl', 'la vie est belle', 'scandal', 'black opium', 'olympea'],
      family: 'Dulce floral',
      mood: ['seductor', 'femenino', 'noche'],
      occasion: ['cita', 'fiesta', 'noche'],
      gender: 'Dama'
    },
    {
      keywords: ['baccarat', 'bacarat', '540', 'instant crush', 'amber oud rouge'],
      family: 'Ámbar dulce',
      mood: ['lujoso', 'intenso', 'exclusivo'],
      occasion: ['evento', 'noche', 'ocasión especial'],
      gender: 'Unisex'
    },
    {
      keywords: ['ombre leather', 'tobacco', 'oud', 'leather', 'cuir'],
      family: 'Cuero especiado',
      mood: ['intenso', 'maduro', 'sofisticado'],
      occasion: ['noche', 'evento formal'],
      gender: 'Unisex'
    },
    {
      keywords: ['light blue', 'acqua di gio', 'versace pour homme', 'nautica', 'dylan blue'],
      family: 'Cítrico acuático',
      mood: ['fresco', 'limpio', 'verano'],
      occasion: ['diario', 'calor', 'playa'],
      gender: 'Caballero'
    }
  ],

  normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  },

  getDNA(product) {
    const text = this.normalize([
      product.name,
      product.title,
      product.fullName,
      product.tags,
      product.vendor
    ].join(' '));

    const matchedRule = this.rules.find(rule => {
      return rule.keywords.some(keyword => {
        return text.includes(this.normalize(keyword));
      });
    });

    return {
      family: matchedRule ? matchedRule.family : 'Sin clasificar',
      mood: matchedRule ? matchedRule.mood : [],
      occasion: matchedRule ? matchedRule.occasion : [],
      gender: matchedRule ? matchedRule.gender : 'Unisex'
    };
  },

  applyToCatalog(products) {
    return products.map(product => {
      const dna = this.getDNA(product);

      return {
        ...product,
        dna,
        family: dna.family,
        mood: dna.mood,
        occasion: dna.occasion,
        gender: dna.gender,
        searchText: [
          product.name,
          product.title,
          product.fullName,
          product.tags,
          product.vendor,
          dna.family,
          dna.gender,
          ...(dna.mood || []),
          ...(dna.occasion || [])
        ].join(' ')
      };
    });
  }
};